import React from "react";

interface Props {
  participant: server.dto.InvoiceParticipant
}

const ParticipantDebugInfo = (props: Props) => {
  if (!site.deploymentValues.debug && !site.isImpersonated) {
    return <></>;
  }

  const { participant } = props;

  return <div>
    <a href={participant.landingUrl} target="_blank" rel="noreferrer">landing</a>
    &nbsp;| {(participant.linkedToUser != null) ? `linked to ${participant.linkedToUser.fullName}` : "not linked to user"}
  </div>;
};

export default ParticipantDebugInfo;